module.exports = __webpack_public_path__ + "06f3c89fd14407284c08d51a87563fce.png";